import {
  Paper,
  Grid,
  Typography,
  Button,
  Box,
  CardMedia,
  IconButton,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import {
  deleteEvent,
  getAllEvents,
  getEventAnalytics,
  getEventAttendees,
  getMyEvents,
  getSingleEvent,
  getVolunteers,
  updateEvent,
} from "../../../../Redux/Reducers/communityReducer";
import { useEffect, useRef, useState } from "react";
import CreateEventModal from "./CreateEventModal";
import { getConnectedReducer } from "../../../../Redux/Reducers/ContactReducer";
import TicketBookingModal from "./TicketBookingModal";
import { getInterviewers } from "../../../../Redux/Reducers/JobReducer";
import { useSelector } from "react-redux";
import { ShareProfile } from "../../MyProfileDetails/ProfileConnectionComponents";
import VideoCameraFrontIcon from "@mui/icons-material/VideoCameraFront";
import { useQuantityContext } from "../../../QuantityContext";
import { Helmet } from "react-helmet";

// Single Event Card Component
const EventCard = ({ event }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const descRef = useRef();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const startTime = new Date(event?.start_time);
  const endTime = new Date(event?.end_time);
  const { openSnackbar } = useQuantityContext();
  const ProfessionalData = useSelector((state) => state?.ProfileArray?.professionaProfile);
  const exploreType = useSelector((state) => state?.community?.exploreType);
  const container = document.querySelector('#events-container');
  if (container) {
    sessionStorage.setItem('eventsScrollPosition', container.scrollTop);
  }
  // Format time as "HH:MM AM/PM"
  const formatTime = (date) => {
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  const handleSingleEventClick = (eventId) => {
    if (editModalOpen || bookingModalOpen || shareModalOpen) return;

    // Save scroll position before navigating
    const eventsContainer = document.querySelector('#events-container');
    if (eventsContainer) {
      sessionStorage.setItem('eventsScrollPosition', eventsContainer.scrollTop);
      sessionStorage.setItem('scrollToEventId', eventId);
    }

    navigate(`/explore/events/${eventId}`, { state: { fromEventId: eventId } });
  };

  const handleNavigateToEvent = (eventId) => {
    dispatch(getSingleEvent(eventId));
    navigate(`/explore/events/${eventId}`);
  };

  const isEventStarted = (startTime) => {
    const currentTime = new Date();
    return currentTime >= new Date(startTime);
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    if (event?.no_of_attendees > 0 || isEventStarted(event?.start_time)) {
      handleNavigateToEvent(event?.id);
    } else {
      dispatch(getSingleEvent(event.id));
      dispatch(getMyEvents({ page: 0, my_events: true, type: exploreType }));
      dispatch(getAllEvents({ page: 0, my_events: false, type: exploreType }));
      setEditModalOpen(true);
    }
  };

  const handleShareSuccess = (msg) => {
    // Optionally show a snackbar or toast
    openSnackbar(msg, "success", 3000);
  };
  const handleShareFailure = (msg) => {
    // Optionally show a snackbar or toast
    openSnackbar(msg, "success", 3000);
  };
  const handleShareEvent = (event) => {
    setShareModalOpen(true);
  };

  const params = { company_name: ProfessionalData?.company_name }

  const handleViewDashboard = (event) => {
    dispatch(getSingleEvent(event?.id));
    dispatch(getVolunteers(event?.id));
    dispatch(getEventAttendees(event?.id));
    dispatch(getEventAnalytics(event?.id))
    navigate(`/community-dashboard/${event?.id}`)
  }

  const handleVolunteerDashboard = (event) => {
    dispatch(getSingleEvent(event?.id));
    dispatch(getVolunteers(event?.id));
    dispatch(getEventAttendees(event?.id));
    dispatch(getEventAnalytics(event?.id))
    navigate(`/community-volunteer-dashboard`)
  }

  const isSameDay = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
};

  return (
    <>
      {/* Conditionally render Helmet only when share modal is open */}
      {shareModalOpen && event && (
        <Helmet>
          <meta key="og-title" property="og:title" content={event.title} />
          <meta key="og-description" property="og:description" content={`Join us on ${new Date(event.start_time).toLocaleDateString()}`} />
          <meta key="og-image" property="og:image" content={event.feature_image} />
          <meta key="og-url" property="og:url" content={`${window.location.origin}/explore/events/${event.id}`} />
          <meta key="og-type" property="og:type" content="event" />
          {event.start_time && (
            <meta key="event-start" property="event:start_time" content={new Date(event.start_time).toISOString()} />
          )}
          {event.end_time && (
            <meta key="event-end" property="event:end_time" content={new Date(event.end_time).toISOString()} />
          )}
          {event.location && (
            <meta key="event-location" property="event:location" content={event.location} />
          )}
        </Helmet>
      )}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 2,
          overflow: "hidden",
          width: "100%",
          cursor: "pointer",
          mb: 1,
        }}
        // onClick={() => navigate(`/event-description/${event.id}`)}
        onClick={() => {
          if (editModalOpen || bookingModalOpen || shareModalOpen) return; // Prevent navigation if any modal is open
          handleSingleEventClick(event?.id);
        }}
      >
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box sx={{ height: { xs: "220px", md: 350 }, width: "100%" }}>
              <CardMedia
                component="img"
                image={
                  event?.feature_image ||
                  "https://static.thenounproject.com/png/4974686-200.png"
                }
                alt={event?.title}
                sx={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                  // borderRadius: 1,
                }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Box sx={{ p: 1.5, flexGrow: 1 }}>
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mb: 1.5 }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", flex: 1 }}
                >
                  {event?.title}
                </Typography>
                {event?.price_amount === 0 && (
                  <Box
                    sx={{
                      bgcolor: "#2e7d32",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "11px",
                      px: 1.2,
                      py: 0.4,
                      borderRadius: "20px",
                      letterSpacing: 1,
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                    }}
                  >
                    FREE
                  </Box>
                )}
              </Box>

              <Box sx={{ display: "flex", gap: 2, mb: 1.5 }}>
                <Box
                  sx={{
                    bgcolor: "action.hover",
                    borderRadius: 1,
                    p: 0.5,
                    minWidth: 48,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "10px", lineHeight: 1.2 }}>
                    {startTime
                      .toLocaleString("default", { month: "short" })
                      .toUpperCase()}
                  </Typography>
                  <Typography variant="h6" color="text.primary" sx={{ fontSize: "18px", lineHeight: 1.2, fontWeight: "bold" }}>
                    {startTime?.getDate()}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  {isSameDay(event?.start_time, event?.end_time) ? (
                    // Same day: Show time range
                    <Typography variant="body2" color="text.primary" sx={{ fontSize: "12px" }}>
                      {formatTime(startTime)} - {formatTime(endTime)}
                    </Typography>
                  ) : (
                    // Different days: Show both dates and times
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                      <Typography variant="body2" color="text.primary" sx={{ fontSize: "12px" }}>
                        <strong>Start:</strong> {startTime.toLocaleDateString("en-US", { month: "short", day: "numeric" })} {formatTime(startTime)}
                      </Typography>
                      <Typography variant="body2" color="text.primary" sx={{ fontSize: "12px" }}>
                        <strong>End:</strong> {endTime.toLocaleDateString("en-US", { month: "short", day: "numeric" })} {formatTime(endTime)}
                      </Typography>
                    </Box>
                  )}
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "11px" }}>
                    {event?.no_of_attendees} Attendees
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: 1, mb: 0.5, alignItems: "center" }}>
                {/* <LocationOnOutlinedIcon color="action" /> */}
                <Typography variant="body1" color="text.primary">
                  {event?.mode === "Online" ? (
                    <VideoCameraFrontIcon
                      fontSize="small"
                      style={{
                        marginRight: 8,
                        verticalAlign: "middle",
                        color: "#757575",
                      }}
                    />
                  ) : (
                    <LocationOnOutlinedIcon
                      fontSize="small"
                      style={{
                        marginRight: 8,
                        verticalAlign: "middle",
                        color: "#757575",
                      }}
                    />
                  )}
                  {event?.event_location ||
                    (event?.mode === "Online"
                      ? "Online Event"
                      : "Location not specified")}
                </Typography>
              </Box>

              {/* <Typography variant="body1" color="text.secondary" paragraph>
              {event.description}
            </Typography> */}
              <Typography
                ref={descRef}
                variant="body2"
                color="text.secondary"
                sx={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  mb: 0,
                  whiteSpace: "pre-line",
                  fontSize: "12px",
                  lineHeight: 1.4,
                }}
              >
                {event?.description}
              </Typography>
              {event?.description?.split("\n").length > 2 || event?.description?.length > 120 ? (
                <Typography
                  variant="body2"
                  sx={{ color: "#0044C6", cursor: "pointer", mt: 0.3, fontSize: "12px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSingleEventClick(event?.id);
                  }}
                >
                  ...more
                </Typography>
              ) : null}

            </Box>

            {/* View Dashboard row — only renders when needed, no empty space otherwise */}
            {event?.is_my_event && (
              <Box sx={{ px: 1, pb: 0, display: "flex", gap: 2 }}>
                <Button
                  variant="outlined"
                  size="large"
                  sx={{ flex: 1, fontSize: "12px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewDashboard(event);
                  }}
                >
                  View Dashboard
                </Button>
              </Box>
            )}

            {/* View Dashboard row — only renders when needed, no empty space otherwise */}
            {(event?.is_volunteer) && (
              <Box sx={{ px: 1, pb: 0, display: "flex", gap: 2 }}>
                <Button
                  variant="outlined"
                  size="large"
                  sx={{ flex: 1, fontSize: "12px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleVolunteerDashboard(event);
                  }}
                >
                  Volunteer Dashboard
                </Button>
              </Box>
            )}

            <Box sx={{ p: 1, display: "flex", gap: 2, alignItems: "center" }}>
              {event?.is_my_event ? (
                <Button
                  variant="contained"
                  size="large"
                  sx={{ flex: 1, background: "#0044C6", fontSize: "12px" }}
                  onClick={handleEditClick}
                >
                  {event?.no_of_attendees > 0 || isEventStarted(event?.start_time) ? "View Details" : "Edit"}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="large"
                  sx={{
                    flex: 1,
                    fontSize: "12px",
                    background: event?.attendees_limit && event?.no_of_attendees >= event?.attendees_limit
                      ? "#ccc"
                      : "#0044C6",
                    '&.Mui-disabled': {
                      color: 'rgba(0, 0, 0, 0.6)',
                      backgroundColor: '#ccc'
                    }
                  }}
                  disabled={event?.attendees_limit && event?.no_of_attendees >= event?.attendees_limit}
                  onClick={(e) => {
                    e.stopPropagation();
                    setBookingModalOpen(true);
                    dispatch(getInterviewers(params));
                    dispatch(getSingleEvent(event?.id));
                  }}
                >
                  {event?.attendees_limit && event?.no_of_attendees >= event?.attendees_limit
                    ? "Seats are full"
                    : event?.price_amount > 0
                      ? `Register ${event?.price_currency || "$"}${event?.price_amount}`
                      : "Register Now"}
                </Button>
              )}
              <IconButton
                size="small"
                sx={{ border: 1, borderColor: "divider" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleShareEvent(event);
                }}
              >
                <ShareRoundedIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        <TicketBookingModal
          open={bookingModalOpen}
          onClose={() => setBookingModalOpen(false)}
          event={event}
        />

        <CreateEventModal
          open={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          editMode={true}
          eventData={event}
          onSubmit={async (formData) => {
            await dispatch(updateEvent({ id: event?.id, data: formData }));
            await dispatch(getSingleEvent(event?.id));
            await dispatch(getMyEvents({ page: 0, my_events: true, type: exploreType }));
            await dispatch(getAllEvents({ page: 0, my_events: false, type: exploreType }));
            setEditModalOpen(false);
          }}
        />
        <ShareProfile
          qrCodeUrl={`${window.location.origin}/explore/events/${event?.id}`}
          open={shareModalOpen}
          onClose={() => setShareModalOpen(false)}
          profileType="event"
          showQr={true}
          isDownload={false}
          handleSuccess={handleShareSuccess}
          handleFailure={handleShareFailure}
          shareData={{
            title: event?.title,
            description: `Join us on ${new Date(event?.start_time).toLocaleDateString()} at ${formatTime(new Date(event?.start_time))}`,
            image: event?.feature_image,
            url: `${window.location.origin}/explore/events/${event?.id}`,
            start_time: event?.start_time,
            end_time: event?.end_time,
            location: event?.event_location || (event?.mode === "Online" ? "Online Event" : "Location not specified")
          }}
        />
      </Paper>
    </>
  );
};

export default EventCard;